import React, {
  FunctionComponent,
  SyntheticEvent,
  useState,
  useEffect,
} from 'react';
import withStyles from 'react-jss';
import { Grid, Button, Card, Form } from 'semantic-ui-react';

import { usePlacesSearch } from 'helpers/usePlacesSearch';
import { ClassProp } from 'helpers/types';
import { USStatesDropDownOptions } from 'helpers/USMapStates';
import FormSelect from 'components/FormSelect';

import styles from './PlacesServiceSearch.styles';

type Styles = ClassProp<ReturnType<typeof styles>>;

type Props = {
  classes: Styles;
};

const PlacesServiceSearch: FunctionComponent<Props> = ({ classes }) => {
  const { writeSearchCache } = usePlacesSearch();
  const [searchValue, setSearchValue] = useState<string>('');
  const [searchStateValue, setSearchStateValue] = useState<string>('');

  // initialize cache
  useEffect(() => {
    writeSearchCache({
      data: {
        placesSearchText: '',
        placesSearchState: '',
      },
    });
  }, []);

  const handleChange = (
    _: SyntheticEvent<HTMLElement, Event>,
    { value, name }: any,
  ) => {
    if (name === 'searchText') return setSearchValue(value);
    if (name === 'searchState') return setSearchStateValue(value);
  };

  const handleSubmitSearch = () => updateSearchData();
  const updateSearchData = () => {
    writeSearchCache({
      data: {
        placesSearchText: searchValue,
        placesSearchState: searchStateValue,
      },
    });
  };

  return (
    <Grid className={classes.searchGrid} columns="equal">
      <Card fluid className={classes.cardContainer}>
        <Card.Content className={classes.cardContent}>
          <Form.Group className={classes.searchGroup}>
            <Form.Input
              className={classes.searchText}
              icon="search"
              iconPosition="left"
              placeholder="Search for venues"
              name="searchText"
              type="text"
              value={searchValue}
              onChange={handleChange}
            />
            <FormSelect
              className={classes.searchState}
              clearable
              options={USStatesDropDownOptions}
              onChange={handleChange}
              value={searchStateValue}
              placeholder="search all states"
              name="searchState"
              search
            />
          </Form.Group>

          <Form.Field id="form-button-control-public">
            <Button className={classes.button} onClick={handleSubmitSearch}>
              Search
            </Button>
          </Form.Field>
        </Card.Content>
      </Card>
    </Grid>
  );
};

export default withStyles(styles)(PlacesServiceSearch);
